<template>
  <v-chip v-if="activity" :small="small" label :color="activity.color" :outlined="isUnknown" :text-color="isUnknown ? undefined : 'white'">
    {{ short ? shortText : activity.label }}
  </v-chip>
  <span v-else-if="dash">—</span>
</template>

<script>
import { ACTIVITY_STATUSES, parseCorpActivity } from '@/common/models/corpActivity';

// Статус и срок кабинета корпа одной плашкой. source — объект корпа или get-me; short — только дата без слов.
export default {
  name: 'CorpActivityChip',
  props: {
    source: { type: Object, default: null },
    small: { type: Boolean, default: true },
    short: { type: Boolean, default: false },
    // Если полей срока нет, показать «—»
    dash: { type: Boolean, default: false },
  },
  computed: {
    activity() {
      return parseCorpActivity(this.source);
    },
    isUnknown() {
      return this.activity.status === ACTIVITY_STATUSES.UNKNOWN;
    },
    shortText() {
      const { activity } = this;
      if (activity.status === ACTIVITY_STATUSES.ACTIVE) return activity.untilText || 'Активен';
      if (activity.status === ACTIVITY_STATUSES.EXPIRED) return activity.untilText ? `Истёк ${activity.untilText}` : 'Истёк';
      return 'Не определён';
    },
  },
};
</script>
